// extracted by mini-css-extract-plugin
module.exports = {"story":"Anchor_story__oCrmA","intro":"Anchor_intro__1Wn27"};